import {
  AfterViewInit,
  Component,
  computed,
  ElementRef,
  EventEmitter,
  input,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { MockComponent } from '@kutil/test';

@Component({
  selector: 'kui-accordion-group',
  templateUrl: './accordion-group.component.html',
  styleUrls: ['./accordion.component.scss'],
  // NOTE: Angular has changed this style recommendation in https://github.com/angular-eslint/angular-eslint/pull/1772
  // TODO: Remove disable-next-line once eslint is updated
  // eslint-disable-next-line @angular-eslint/no-host-metadata-property
  host: {
    '[class.on-background]': 'onBackground()',
  },
})
export class AccordionGroupComponent implements OnInit, AfterViewInit {
  key = input('');
  initialStateOpen = input(true); // defaults to open
  onBackground = input(false);
  toggleText = input(''); // translate before passing in

  @Output() didChange = new EventEmitter<boolean>();

  isOpen = false;
  bodyOpenHeight = 0;
  isAnimating = false;
  uniqueKey = computed(() => `${this.key()}_${Math.round(Math.random() * 1000000)}`); // random to ensure keys are unique

  @ViewChild('input', { static: false }) inputCheckbox: ElementRef;
  @ViewChild('collapsibleBody', { static: false }) collapsibleBody: ElementRef;

  ngOnInit() {
    this.isOpen = this.initialStateOpen();
  }

  ngAfterViewInit() {
    if (!this.isOpen && this.collapsibleBody) {
      (this.collapsibleBody.nativeElement as HTMLElement).style.height = '0px';
    }
    setTimeout(() => {
      this.bodyOpenHeight = ((this.collapsibleBody?.nativeElement as HTMLElement)?.scrollHeight as number) || 0;
      this._updateAccordion(this.isOpen);
    }, 400);
  }

  accordionClick(isChecked: boolean) {
    this._updateAccordion(isChecked);
    this.didChange.emit(isChecked);

    // blur and focus checkbox in order to update voiceover text if in use
    this.isAnimating = true;
    (this.inputCheckbox.nativeElement as HTMLElement).blur();
    setTimeout(() => {
      (this.inputCheckbox.nativeElement as HTMLElement).focus();
      this.isAnimating = false;
    }, 400);
  }

  private _updateAccordion(isChecked: boolean) {
    this.isOpen = isChecked;
    if (this.collapsibleBody) {
      // update bodyOpenHeight in case content has changed since ViewInit
      this.bodyOpenHeight = ((this.collapsibleBody?.nativeElement as HTMLElement)?.scrollHeight as number) || 0;
      (this.collapsibleBody.nativeElement as HTMLElement).style.height = isChecked ? `${this.bodyOpenHeight}px` : '0px';

      // TODO: Consider making this functionality a directive
      (this.collapsibleBody.nativeElement as HTMLElement)
        .querySelectorAll('[data-focusable]')
        ?.forEach((focusableEl) => {
          if (this.isOpen) {
            focusableEl.removeAttribute('tabindex');
            focusableEl.removeAttribute('aria-hidden');
          } else {
            focusableEl.setAttribute('tabindex', '-1');
            focusableEl.setAttribute('aria-hidden', 'true');
          }
        });
    }
  }
}

export const MockAccordionGroupComponent = MockComponent({
  selector: 'kui-accordion-group',
  inputs: ['key', 'initialStateOpen', 'onBackground', 'toggleText'],
  template: '<ng-content></ng-content>',
});
